import { IconWarningRegular, Spinner, Stack, Text3, skinVars, useDialog } from '@telefonica/mistica';
import { AxiosError } from 'axios';
import React, { useEffect } from 'react';
import { logout } from '../../services/LoginService';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Logout: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { dialog } = useDialog();

    useEffect(() => {
        logout()
            .then(() => {
                navigate('/login');
            })
            .catch((error: AxiosError) => {
                if ([401, 403, 410].includes(Number(error.response?.status))) {
                    navigate('/login');
                } else {
                    dialog({
                        asset: <IconWarningRegular color={skinVars.colors.feedbackErrorBackground} size={64} />,
                        title: t('profileFeedbackErrorTitle'),
                        message: (() => {
                            return (
                                <Stack space={16}>
                                    <Text3 light color={skinVars.colors.borderHigh}>
                                        {t('genericErrorDescription')}
                                    </Text3>
                                </Stack>
                            );
                        })() as any,
                        acceptText: t('buttonUnderstoodFeedback'),
                        onAccept() {
                            window.close();
                        },
                    });
                }
            });
    }, []);

    return (
        <div className='c-spinner'>
            <Spinner size={24} />
            <span className='c-spinner-overlay'></span>
        </div>
    );
};

export default Logout;
